import _defineProperty from "/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { composeRefs as e } from "@radix-ui/react-compose-refs";
import * as t from "react";
import r from "@babel/runtime/helpers/esm/extends";
export var Slot = /*#__PURE__*/t.forwardRef(function (e, o) {
  var a = e.children,
      s = _objectWithoutProperties(e, ["children"]);

  return t.Children.toArray(a).some(l) ? /*#__PURE__*/t.createElement(t.Fragment, null, t.Children.map(a, function (e) {
    return l(e) ? /*#__PURE__*/t.createElement(n, r({}, s, {
      ref: o
    }), e.props.children) : e;
  })) : /*#__PURE__*/t.createElement(n, r({}, s, {
    ref: o
  }), a);
});
Slot.displayName = "Slot";
var n = /*#__PURE__*/t.forwardRef(function (r, n) {
  var l = r.children,
      a = _objectWithoutProperties(r, ["children"]);
  /*#__PURE__*/


  return t.isValidElement(l) ? /*#__PURE__*/t.cloneElement(l, _objectSpread(_objectSpread({}, o(a, l.props)), {}, {
    ref: e(n, l.ref)
  })) : t.Children.count(l) > 1 ? t.Children.only(null) : null;
});
n.displayName = "SlotClone";
export var Slottable = function Slottable(_ref) {
  var e = _ref.children;
  return /*#__PURE__*/t.createElement(t.Fragment, null, e);
};

function l(e) {
  /*#__PURE__*/
  return t.isValidElement(e) && e.type === Slottable;
}

function o(e, t) {
  var r = _objectSpread({}, t);

  var _loop = function _loop(_n) {
    var l = e[_n],
        o = t[_n];
    /^on[A-Z]/.test(_n) ? r[_n] = function () {
      null == o || o.apply(void 0, arguments), null == l || l.apply(void 0, arguments);
    } : "style" === _n ? r[_n] = _objectSpread(_objectSpread({}, l), o) : "className" === _n && (r[_n] = [l, o].filter(Boolean).join(" "));
  };

  for (var _n in t) {
    _loop(_n);
  }

  return _objectSpread(_objectSpread({}, e), r);
}

export var Root = Slot;